var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showTimeRemaining)?_c('h4',{staticClass:"vertical-center pr-2"},[_vm._v(_vm._s(_vm.timeRemaining)+" Remaining")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }